import { JSX, useState, useEffect, useRef } from 'react';
import NoteManager from '../../todolist/data/noteManager';
import { NoteProps } from '../../note/note';
import './notePreview.css';
import WindowBar from '../../common/windowBar/windowBar';
import NoteIcon from '../../assets/images/icons/Save.png';
import { generateHTML , generateJSON } from '@tiptap/react';
import StarterKit from '@tiptap/starter-kit'
import TaskList from '@tiptap/extension-task-list';
import TaskItem from '@tiptap/extension-task-item';
import checkBoxIcon from '../../assets/images/text-editor/list.png';
import boldTextIcon from '../../assets/images/text-editor/bold-text.png'

const NotePreview = ({setLoading, topRef, maxHeight}: {setLoading: (loading: boolean) => void, topRef: React.RefObject<any>, maxHeight: number}): JSX.Element => {
    const noteManager = NoteManager.getInstance();
    const [notes, setNotes] = useState<NoteProps[]>();
    const [latestNote, setLatestNote] = useState<NoteProps>(() => {
        return notes?.length ? notes[0] : null;
    });
    const [isLoading, setIsLoading] = useState(true);
    const windowBarRef = useRef(null);
    const [windowBarHeight, setWindowBarHeight] = useState(0);

    const refreshTodos = async () => {
        try {
            const fetchedTodos = await noteManager.getNotes(); // Now waits for initialization
            setNotes([...fetchedTodos]);
        } catch (error) {
            console.error('Failed to fetch todos:', error);
        } finally {
            setIsLoading(false);
            setLoading(false);
        }
    };

    useEffect(() => {
        // Subscribe to updates
        const unsubscribe = noteManager.subscribe(refreshTodos);
        
        // Initial load
        refreshTodos();

        // Cleanup subscription on unmount
        return () => unsubscribe();
    }, []);
    
    useEffect(() => {
        if (notes?.length) {
            setLatestNote(notes[0]);
        }
    }, [notes]);

    useEffect(() => {
        refreshTodos();
    }, []);

    useEffect(() => {
        const updateWindowBarHeight = () => {
            console.log("bar window recalculate")
            if (windowBarRef.current) {
                const barHeight = windowBarRef.current.getBoundingClientRect().height;
                setWindowBarHeight(barHeight);
                console.log(`windows bar height: ${barHeight}`);
            }
        };
    
        // Create a slight delay to ensure the DOM is ready
        const timeoutId = setTimeout(() => {
            updateWindowBarHeight();
          }, 200); 
        
        // Also add resize observer to handle dynamic size changes
        const resizeObserver = new ResizeObserver(updateWindowBarHeight);
        if (windowBarRef.current) {
            resizeObserver.observe(windowBarRef.current);
        }
    
        return () => {
            clearTimeout(timeoutId);
            resizeObserver.disconnect();
        };

    }, []);


    function DisplayNote(note: NoteProps) {
        const jsonContent = generateJSON(note.content, [
            StarterKit,
            TaskList,
            TaskItem.configure({
              nested: true,
            }),
          ]);
        const html = generateHTML(jsonContent, [
          StarterKit,
          TaskList,
          TaskItem.configure({
            nested: true,
          }),
        ]);
      
        return <div dangerouslySetInnerHTML={{ __html: html }} />;
      }

    if (isLoading) {
        return <div>Loading...</div>;
    }

    return (
        <div className='note-preview-outter-container outter-container' ref={topRef}>
            <div className='pixel-container-back'/>
            <div className='pixel-container-top'>
                <div className='pixel-container-border'>
                    <WindowBar title={latestNote? latestNote.title: 'Go add a new note!!!'} IconSrc={NoteIcon} onClick={()=>{}} barRef={windowBarRef}/>
                    <div className='note-content-container main-pixel-container ProseMirror'style={{ 
                    maxHeight: `calc(${maxHeight}px - ${windowBarHeight}px - 10px)`,
                    overflowY: 'auto'
                    }}>
                        { latestNote && DisplayNote(latestNote) }
                        {/* <EditorContent editor={editor} /> */}
                    </div>
                </div>
            </div>
    </div>
    ); 
};
  
export default NotePreview;